import axios from 'axios';

export const getBrokerTarget = () => axios.get('/backoffice/dashboards/broker_target/');

export const getPartnerTarget = partnerId => axios.get(`/backoffice/dashboards/partner_target/${partnerId}/`);

export const getClientPartnerTarget = () => axios.get(`/dashboards/partner_target/`);

export const getManagerTarget = partnerId => axios.get(`/backoffice/dashboards/manager_target/${partnerId}/`);

export const putBrokerTarget = data => axios.put('/backoffice/dashboards/broker_target/', data);

export const putPartnerTarget = (partnerId, data) =>
  axios.put(`/backoffice/dashboards/partner_target/${partnerId}/`, data);

export const putClientPartnerTarget = data => axios.put(`/dashboards/partner_target/`, data);

export const putManagerTarget = (partnerId, data) =>
  axios.put(`/backoffice/dashboards/manager_target/${partnerId}/`, data);

export const getBackofficeEvents = (partnerId, mode, brand) =>
  axios.get(`/backoffice/dashboards/events/${partnerId ? `?user=${partnerId}` : ''}`, {
    params: { page: 1, page_size: 50, view_mode: mode, brand },
  });

export const getTotals = ({ sampleType, accountableUsers, brand }) =>
  axios.get('/backoffice/dashboards/totals/', { params: { sampleType, accountableUsers, brand } });

export const getClientTotals = ({ sampleType, accountableUsers, brand }) =>
  axios.get('/dashboards/totals/', { params: { sampleType, accountableUsers, brand } });

export const getPartnershipEvents = () => axios.get('/dashboards/events/', { params: { page: 1, page_size: 50 } });

export const getBackofficeHistory = search => axios.get(`/backoffice/dashboards/history/`, { params: { ...search } });

export const getMonthFunnel = (startDate, endDate, sampleType, accountableUsers, aggregations, brand) =>
  axios.get('/backoffice/dashboards/metrics/', {
    params: { start: startDate, end: endDate, sampleType, accountableUsers, aggregations, brand },
  });

export const getClientMonthFunnel = (
  startDate,
  endDate,
  sampleType,
  accountableUsers,
  aggregations,
  brand,
  referType
) =>
  axios.get('/dashboards/metrics/', {
    params: { start: startDate, end: endDate, sampleType, accountableUsers, aggregations, brand, referType },
  });
